import { Button, Col, Modal, Row } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import Table from "react-bootstrap/Table";
import CompanyTypeEnum from "../../../enums/CompanyTypeEnum";

const CallForPriceModal = ({ modal, setModal, data }) => {
  return (
    <Modal show={modal} direction="rtl" centered className="modal-lg">
      <Modal.Header>
        <Modal.Title>لیست سرویس های پستی برای این مرسوله</Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="d-flex align-item-center justify-content-center text-right  "
        style={{ textAlign: "right", direction: "rtl" }}
      >
        <div className="w-100">
          <Table
            responsive
            bordered
            striped
            className="text-center align-middle"
          >
            <thead>
              <tr>
                <th></th>
                <th className="text-secondary">نام سرویس دهنده</th>
                <th className="text-secondary">نوع سرویس</th>
                <th className="text-secondary">قیمت بارکد پستی</th>
                <th className="text-secondary">قیمت نهایی</th>
              </tr>
            </thead>

            <tbody>
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Image
                      style={{
                        width: 90,
                        objectFit: "contain",
                        height: 60,
                      }}
                      src={item.companyImage}
                    />
                  </td>
                  <td>{item.companyName}</td>
                  <td>{CompanyTypeEnum[item.serviceTypeId]}</td>
                  <td>{item.quote?.toLocaleString()} ريال</td>
                  <td>
                    <span className="fs-4 fw-bold m-0">
                      {item.totalPrice?.toLocaleString()}
                    </span>
                    <span className="fs-small"> ریال</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <Modal.Footer className="d-flex align-item-center justify-content-center">
            <Row className="mx-5 px-5">
              <Col>
                <Button
                  className="btn-cancel-style"
                  onClick={() => setModal(false)}
                >
                  بستن
                </Button>
              </Col>
            </Row>
          </Modal.Footer>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CallForPriceModal;
